var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "l-map",
        {
          ref: "map",
          staticClass: "map-view",
          class: {
            "low-resolution": _vm.$lowResolution,
            "extra-low-resolution": _vm.$xlResolution,
            embedded: _vm.$store.getters.embed,
            "click-to-pick": _vm.clickToPickActive,
            "hide-controls": !_vm.showControls
          },
          style: { height: _vm.mapHeight + "px" },
          attrs: {
            id: _vm.constants.mapViewElementId,
            "max-zoom": _vm.maxZoom,
            "min-zoom": 2,
            center: _vm.mapCenter,
            zoom: _vm.zoom,
            options: _vm.mapOptions
          },
          on: {
            contextmenu: function($event) {
              return _vm.mapRightClick.apply(null, arguments)
            },
            zoomend: _vm.zoomed,
            baselayerchange: _vm.baseLayerChanged,
            click: function($event) {
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.mapLeftClick.apply(null, arguments)
            },
            dragend: _vm.mapMoved
          }
        },
        [
          _vm.showControls && _vm.distanceMeasureToolAvailable
            ? _c("l-control-polyline-measure", {
                attrs: { options: _vm.polylineMeasureOptions }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("map-view-markers", {
            attrs: { mode: _vm.mode, markers: _vm.markers },
            on: {
              markerMoved: _vm.markerMoved,
              markerClicked: _vm.markerClicked,
              removePlace: _vm.removePlace,
              markAsDirectFromHere: _vm.markAsDirectFromHere
            }
          }),
          _vm._v(" "),
          _c("map-view-markers", {
            attrs: { mode: _vm.mode, markers: _vm.pois, "is-poi": "" },
            on: { markerClicked: _vm.markerClicked }
          }),
          _vm._v(" "),
          _vm.polygons
            ? [
                _vm._l(_vm.polygons, function(polygon, index) {
                  return [
                    polygon.properties.visible
                      ? _c(
                          "l-polygon",
                          {
                            key: index + "-polygon",
                            attrs: {
                              "lat-lngs": polygon.latlngs,
                              opacity: polygon.properties.opacity,
                              fillOpacity: polygon.properties.fillOpacity,
                              fillColor: polygon.properties.fillColor,
                              color: polygon.properties.color
                            },
                            on: {
                              click: function($event) {
                                return _vm.isochroneClicked(
                                  index,
                                  polygon,
                                  $event
                                )
                              }
                            }
                          },
                          [
                            polygon.properties.label
                              ? _c("l-popup", [
                                  _c(
                                    "div",
                                    {
                                      ref: "isochronePopupContainer" + index,
                                      refInFor: true
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(polygon.properties.label) +
                                          " " +
                                          _vm._s(_vm.$t("mapView.polygon")) +
                                          " - " +
                                          _vm._s(polygon.properties.area) +
                                          "\n              "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      polygon.properties.total_pop
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("global.population")
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  polygon.properties.total_pop
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.circleMarker
            ? _c("l-circle-marker", {
                attrs: {
                  weight: 2,
                  color: "#1D1D1E",
                  fill: true,
                  fillColor: "#fff",
                  fillOpacity: 0.9,
                  "lat-lng": _vm.circleMarker.center,
                  radius: _vm.circleMarker.radius
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.myPositionMarker
            ? _c(
                "l-circle-marker",
                {
                  attrs: {
                    weight: 2,
                    color: "#1D1D1E",
                    fill: true,
                    fillColor: "#1C97F3",
                    fillOpacity: _vm.myPositionMarker.opacity,
                    "lat-lng": _vm.myPositionMarker.center,
                    radius: _vm.myPositionMarker.radius
                  }
                },
                [
                  _c("l-popup", [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("mapView.yourCurrentLocation")) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("mapView.accuracy")) +
                          ":\n          " +
                          _vm._s(_vm.myPositionMarker.accuracy.toFixed(1)) +
                          " " +
                          _vm._s(_vm.$t("global.units.m")) +
                          "\n        "
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.alternativeRoutes, function(alternativeRoute) {
            return [
              _c("ors-l-polyline", {
                key: alternativeRoute.properties.index,
                attrs: {
                  "not-active": "",
                  color: _vm.alternativeRouteColor,
                  route: alternativeRoute
                },
                on: {
                  click: function($event) {
                    return _vm.alternativeRouteIndexSelected(
                      alternativeRoute.properties.index,
                      $event
                    )
                  }
                }
              })
            ]
          }),
          _vm._v(" "),
          _vm.displayActiveRouteData
            ? [
                _c("ors-l-polyline", {
                  attrs: {
                    draggable: _vm.isPolylineDraggable,
                    "focused-poly-index": _vm.highlightedRoutePointIndex,
                    route: _vm.activeRouteData,
                    "tooltip-icon": _vm.routingProfileIcon
                  },
                  on: {
                    rightClicked: _vm.mapRightClick,
                    addStopViaPolylineDrag: _vm.addStopViaPolylineDrag
                  }
                })
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("l-control-layers", {
            attrs: { position: _vm.layersPosition, collapsed: true }
          }),
          _vm._v(" "),
          _vm._l(_vm.tileProviders, function(tileProvider) {
            return _c("l-tile-layer", {
              key: tileProvider.name,
              attrs: {
                name: tileProvider.name,
                visible: tileProvider.visible,
                url: tileProvider.url,
                attribution: tileProvider.attribution,
                token: tileProvider.token,
                options: { maxZoom: tileProvider.maxZoom },
                "layer-type": "base"
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.overlayerTileProviders, function(layer) {
            return _c("l-tile-layer", {
              key: layer.name,
              attrs: {
                name: layer.name,
                visible: layer.visible,
                url: layer.url,
                attribution: layer.attribution,
                token: layer.token,
                "layer-type": "overlay"
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.wmsOverlayerTileProviders, function(layer) {
            return _c("l-wms-tile-layer", {
              key: layer.name,
              attrs: {
                attribution: layer.attribution,
                "base-url": layer.baseUrl,
                layers: layer.layers,
                visible: layer.visible,
                name: layer.name,
                "max-zoom": layer.maxZoom,
                version: layer.version,
                format: layer.format,
                transparent: true,
                opacity: layer.opacity,
                "layer-type": "overlay"
              }
            })
          }),
          _vm._v(" "),
          _vm.accessibilityToolAvailable
            ? _c(
                "v-btn",
                {
                  staticClass:
                    "do-not-trigger-close-bottom-nav accessibility-btn",
                  class: { "extra-low-resolution": _vm.$xlResolution },
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("maps.toggleAccessibleMode")
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toggleAccessibleMode.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        large: "",
                        color: _vm.$store.getters.mapSettings
                          .accessibleModeActive
                          ? "primary"
                          : "default"
                      }
                    },
                    [_vm._v("accessibility")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canFitFeatures && _vm.showControls
            ? _c(
                "v-btn",
                {
                  staticClass: "fit-all-features",
                  class: { "extra-low-resolution": _vm.$xlResolution },
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("mapView.fitAllFeatures")
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.fitAllFeatures()
                    }
                  }
                },
                [_c("v-icon", { attrs: { large: "" } }, [_vm._v("all_out")])],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.extraInfo
            ? _c("extra-info-highlight", {
                attrs: {
                  "extra-info": _vm.extraInfo,
                  "polyline-data": _vm.activeRouteData.geometry.coordinates
                },
                on: {
                  closed: function($event) {
                    _vm.extraInfo = null
                  },
                  beforeOpen: function($event) {
                    _vm.isAltitudeModalOpen = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isAltitudeModalOpen
            ? _c("l-height-graph", {
                attrs: {
                  lg8: "",
                  sm11: "",
                  data: _vm.localMapViewDataRawData,
                  options: _vm.lHeightGraphOptions
                },
                on: { closed: _vm.closeAltitudeInfo }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showMyLocationControl
            ? _c("my-location", {
                staticClass: "my-location-btn",
                attrs: { active: _vm.myLocationActive },
                on: { updateLocation: _vm.updateMyLocation }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showBrand && _vm.showControls
            ? _c("img", {
                staticClass: "over-brand",
                attrs: {
                  src: _vm.getImgSrc("brandLogoSrc"),
                  alt: _vm.$t("global.brand"),
                  title: _vm.$t("global.brand")
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            ref: "customMapControlsContainer",
            staticClass: "custom-controls",
            staticStyle: { "z-index": "501" }
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.$store.getters.embed
        ? _c(
            "v-btn",
            {
              staticClass: "view-on-ors",
              attrs: {
                small: "",
                title: _vm.$t("mapView.viewOnORS"),
                target: "_blank",
                href: _vm.nonEmbedUrl
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("mapView.viewOnORS")) + " "),
              _c("v-icon", { attrs: { right: "", small: "" } }, [
                _vm._v("open_in_new")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$store.getters.embed
        ? _c("map-right-click", {
            attrs: { "map-view-data": _vm.mapViewData },
            on: {
              closed: function($event) {
                _vm.clickLatlng = null
              },
              rightClickEvent: _vm.handleRightClickEvent
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("map-left-click", {
        attrs: {
          show: _vm.showControls && _vm.showClickPopups,
          "current-zoom": _vm.zoom
        },
        on: {
          closed: function($event) {
            _vm.clickLatlng = null
          },
          directionsToPoint: _vm.directionsToPoint
        }
      }),
      _vm._v(" "),
      _vm.$store.getters.mapSettings.accessibleModeActive
        ? _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  staticClass:
                    "move-map-arrow left do-not-trigger-close-bottom-nav",
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("mapView.moveMapPositionToLeft")
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveMapCenter("left")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                    _vm._v("arrow_back")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass:
                    "move-map-arrow up do-not-trigger-close-bottom-nav",
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("mapView.moveMapPositionToUp")
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveMapCenter("up")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                    _vm._v("arrow_upward")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass:
                    "move-map-arrow right do-not-trigger-close-bottom-nav",
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("mapView.moveMapPositionToRight")
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveMapCenter("right")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                    _vm._v("arrow_forward")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass:
                    "move-map-arrow down do-not-trigger-close-bottom-nav",
                  style: { top: _vm.accessibilityBtnTopPosition },
                  attrs: {
                    fab: "",
                    small: "",
                    title: _vm.$t("mapView.moveMapPositionToDown")
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveMapCenter("down")
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                    _vm._v("arrow_downward")
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47398b26", { render: render, staticRenderFns: staticRenderFns })
  }
}